/*
 *   Copyright (c) 2021 vlinder Inc.
 *   All rights reserved.
 *   This software is proprietary of vlinder Inc. and can not be distributed / used for any purpose outside of vlinder Inc. without explicit written consent from the copyright owner.
 */

import styled from 'styled-components';
import Image from 'react-bootstrap/Image';
import { motion } from 'framer-motion';

const convertHexToRGBA = (hexCode?: string, opacity = 15) => {
  if (hexCode) {
    let hex = hexCode.replace('#', '');

    if (hex.length === 3) {
      hex = `${hex[0]}${hex[0]}${hex[1]}${hex[1]}${hex[2]}${hex[2]}`;
    }

    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);

    /* Backward compatibility for whole number based opacity values. */
    if (opacity > 1 && opacity <= 100) {
      opacity = opacity / 100;
    }

    return `rgba(${r},${g},${b},${opacity})`;
  }
  return null;
};

export const ListContainer = styled(motion.div)`
  display: flex;
  cursor: pointer;
  justify-content: flex-start;
  align-items: flex-start;
  margin: 1.5rem;
  background-color: white;
  border-radius: 10px !important;
  box-shadow: 2px 2px 5px lightgray;
  padding: 20px 20px 0 20px !important;
  @media (max-width: 480px) {
    align-items: flex-start;
    margin: 0.8rem 0.2rem;
  }
  .toggle-menu {
    display: none;
    @media (max-width: 480px) {
      display: block;
    }
  }
  &:hover .toggle-menu {
    display: block;
  }
`;

export const IndexContainer = styled.div`
  @media (max-width: 480px) {
    display: none;
  }
`;

export const IconImage: any = styled(Image)`
  width: 50px;
  height: 50px;
  cursor: pointer;
  text-align: center;
  object-fit: cover;
  box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px,
    rgba(60, 64, 67, 0.15) 0px 1px 3px 1px;
  .avatar {
    overflow: none !important;
  }
`;

export const IconImagePlaceholder: any = styled(Image)`
  width: auto;
  height: 50px;
  @media (max-width: 480px) {
    width: 60px;
    height: 45px;
  }
  object-fit: contain;
  max-width: 100%;
  max-height: 100%;
  margin: 0px auto;
  text-align: center;
  padding: 5px;
`;

export const ImageContainer = styled.div`
  border-radius: 0.5em;
  width: 100%;
  height: 100%;
  overflow: hidden;
  backdrop-filter: blur(50px);
  object-fit: contain;
  position: relative;
  background-color: rgba(255, 255, 255, 0.1);
  margin: 0px;
  min-width: 0px;
`;

export const Title = styled.h6`
  font-size: 0.9em;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  @media (max-width: 480px) {
    font-size: 0.8em;
  }
`;

export const Meta = styled.p`
  font-size: 0.8em;
  color: #8f8f8f;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  margin-left: -3em;
  overflow: hidden;
  text-overflow: ellipsis;
  @media (max-width: 480px) {
    font-size: 0.7em;
  }
`;

export const IconWrapper = styled.div`
  background-color: transparent;
`;

export const IconContainer = styled.div`
  width: 50px;
  height: 50px;
  background-color: #104382 !important;
  @media (max-width: 480px) {
    height: 40px;
  }
  display: flex;
  box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px,
    rgba(60, 64, 67, 0.15) 0px 1px 3px 1px;
`;

export const MetaLogo: any = styled(Image)`
  width: 20px;
  height: auto;
  border-radius: 10px;
  object-fit: contain;
  margin-top: -3px;
  padding: 1px;
`;

export const RightContainer = styled.div`
  height: 85vh;
  overflow: scroll;
  -ms-overflow-style: none; /* for Internet Explorer, Edge */
  scrollbar-width: none; /* for Firefox */
  &::-webkit-scrollbar {
    display: none; /* for Chrome, Safari, and Opera */
  }
  @media (max-width: 480px) {
    height: auto;
  }
`;

export const ToggleContainer = styled.div`
  margin-left: auto;
  @media (max-width: 480px) {
    margin-left: 0;
    margin: auto;
  }
`;

export const HorizontalDivider = styled.hr`
  color: #8f8f8f;
  position: relative;
  // z-index: -99;
`;

export const SectionDivider = styled.hr`
  color: #8f8f8f;
`;

export const SectionTitle = styled.h4`
  display:flex;
  font-size:1.0em;
  justify-content:space-between;
  align-items:center;
  font-weight: bold;
  padding:left:1rem;
  margin-left:1.5rem;
  @media (max-width: 480px) {
    padding-left:0;
    margin-left:1rem;
  }
`;

export const ViewAllContainer = styled.span`
  font-size: 1rem;
  @media (max-width: 480px) {
    font-size: 0.9rem;
  }
`;

export const ButtonComp: any = styled.button`
  background-color: ${(props) => convertHexToRGBA(props?.color)};
  color: ${(props) => props?.color};
  padding: 2px 5px;
  margin: 0;
  font-size: 0.8em;
  font-weight: bolder;
`;
